
import { ROUTER_AGREEMENT, ROUTER_CREATE_PROFILE, ROUTER_HABC_QUESTIONNAIRE, ROUTER_HABC_QUESTIONNAIRE_PREFIX, ROUTER_HABC_SUCCESS, ROUTER_HASE_AGREEMENT, ROUTER_OUTSIDE_SUCCESS, ROUTER_QUESTIONNAIRE, ROUTER_QUESTIONNAIRE_PREFIX, ROUTER_VERIFICATION, ROUTER_VERIFY_PROFILE } from 'constants/outside-router';
import { ROUTER_COMPANY_LIST, ROUTER_DATA_COLLECTION_PLATFORM, ROUTER_RISK_TRACKING } from 'constants/router';
import React, { lazy, Suspense, useMemo } from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { Location } from 'history';
import { SentryRoute as Route, Spin } from '@miotech/shared';
import useRedux from 'hooks/useRedux';

const QuestionairePage = lazy(() => import('./pages/outside-system/hsbc/questionnaire/index'));
const VerificationPage = lazy(() => import('./pages/outside-system/verification/index'));
const AgreementPage = lazy(() => import('./pages/outside-system/hsbc/agreement/index'));
const BorrowerSuccessfullyPage = lazy(() => import('./pages/borrower/successfully/index'));
// hase
const VerifyProfilePage = lazy(() => import('./pages/outside-system/hase/verify-profile/index'));
const CreateProfilePage = lazy(() => import('./pages/outside-system/hase/create-profile/index'));
const QuestionnairePage = lazy(() => import('./pages/outside-system/hase/questionnaire/index'));
const HaseAgreementPage = lazy(() => import('./pages/outside-system/hase/agreement/index'));
const HaseSuccessfullyPage = lazy(() => import('./pages/outside-system/hase/successfully/index'));

interface LocationState {
  background: Location;
}

const ESGRISKDD = '/esg-risk-dd';

const outsideLayoutRouters = [
  ROUTER_QUESTIONNAIRE_PREFIX,
  ROUTER_VERIFICATION,
  ROUTER_AGREEMENT,
  ESGRISKDD,
  ROUTER_OUTSIDE_SUCCESS,
  ROUTER_VERIFY_PROFILE,
  ROUTER_CREATE_PROFILE,
  ROUTER_HABC_QUESTIONNAIRE_PREFIX,
  ROUTER_HASE_AGREEMENT,
  ROUTER_HABC_SUCCESS
];

const OutsideContainer: React.FC = () => {
  const location = useLocation<LocationState>();
  const { selector: { resourceList } } = useRedux(s => s.userRole);
  const isHSBC = useMemo(() =>
    resourceList?.find((item: any) =>
      item.routePath === ROUTER_COMPANY_LIST
    )?.selected,
    [resourceList]
  );
  const isHABC = useMemo(() =>
    resourceList?.find((item: any) =>
      item.routePath === ROUTER_RISK_TRACKING
    )?.selected,
    [resourceList]
  );

  const memoRoute = useMemo(() => {
    // 如果是 HSBC 用户，则重定向到 borrower-list 页面
    if (isHSBC && ['/'].includes(location.pathname)) {
      return <Redirect to={ROUTER_COMPANY_LIST} />;
    }
    if (isHABC && ['/'].includes(location.pathname)) {
      return <Redirect to={`${ROUTER_DATA_COLLECTION_PLATFORM}/listed`} />;
    }

    return (
      <div>
        <Suspense
          fallback={
            <Spin>
              <div style={{ height: '100px' }}></div>
            </Spin>
          }
        >
          <Switch location={location}>
            <Route
              path={`(${outsideLayoutRouters.join('|')})`}
              component={() => {
                return (<Switch>
                  <Suspense
                    fallback={
                      <Spin>
                        <div style={{ height: '100px' }}></div>
                      </Spin>
                    }
                  >
                    <Route path={ROUTER_QUESTIONNAIRE} exact component={QuestionairePage} />
                    <Route path={ROUTER_VERIFICATION} exact component={VerificationPage} />
                    <Route path={ROUTER_AGREEMENT} exact component={AgreementPage} />
                    <Route path={ROUTER_OUTSIDE_SUCCESS} exact component={BorrowerSuccessfullyPage} />
                    <Route path={ROUTER_VERIFY_PROFILE} exact component={VerifyProfilePage} />
                    <Route path={ROUTER_CREATE_PROFILE} exact component={CreateProfilePage} />
                    <Route path={ROUTER_HABC_QUESTIONNAIRE} exact component={QuestionnairePage} />
                    <Route path={ROUTER_HASE_AGREEMENT} exact component={HaseAgreementPage} />
                    <Route path={ROUTER_HABC_SUCCESS} exact component={HaseSuccessfullyPage} />
                  </Suspense>
                </Switch>
                );
              }}
            />
          </Switch>
        </Suspense>
      </div>
    );
  }, [isHSBC, location, isHABC]);
  return memoRoute;
};

export default OutsideContainer;
